<kt-portlet class="knostos-grid">
  <kt-portlet-header
    title="Image Requests"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 140px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(filteredStatus) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(filteredStatus) }}
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="patientId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Patient ID</mat-header-cell>
          <mat-cell *matCellDef="let request" class="gl-block">
            <span matTooltip="View Request" (click)="viewRequest(request)">{{
              request.patient_id
            }}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="patientLastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.PATIENT' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let request" class="gl-block flex-column align-items-start">
            <span matTooltip="View Request">
              {{ request.patient_first_name }} {{ request.patient_last_name }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PATIENT.INPUT.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(request.status)
              }} label-inline text-center"
            >
              {{ getItemStatusString(request.status) }}
            </span>
          </mat-cell>
        </ng-container>
        <!-- start -->
        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Date Requested</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <span> {{ request.created | date : 'MM-dd-yy, h:mm a' }} </span>
          </mat-cell>
        </ng-container>
        <!-- end -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <ng-template ngxPermissionsOnly="canViewPatientImageRequest">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Patient"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewRequest(request)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-container>
              <ng-template ngxPermissionsOnly="canApprovePatientImageRequest">
                <button
                  [disabled]="!request.actions.includes('approve')"
                  matTooltip="Approve Request"
                  class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                  (click)="approveRequest(request)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/Code/Done-circle.svg"
                    class="svg-icon svg-icon-md svg-icon-success"
                  ></span>
                </button>
              </ng-template>
              <ng-template ngxPermissionsOnly="canDenyPatientImageRequest">
                <button
                  [disabled]="!request.actions.includes('deny')"
                  matTooltip="Deny Request"
                  class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                  (click)="denyRequest(request)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/Code/Error-circle.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </ng-template>
            </ng-container>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
